export const YYYY_MMMM_DD_HMS = 'YYYY.MMMM.DD HH:mm:ss';
export const YYYY_MM_DD_HMS = 'YYYY-MM-DD HH:mm:ss';
